/*
 * @Author: HB-BruceWang
 * @Date: 2025-02-24 18:43:39
 * @LastEditors: HB-BruceWang
 * @LastEditTime: 2025-02-26 09:17:20
 * @FilePath: \shopify-web\src\pages\paid-extended-warranty\snippets\form\js\get-pew-purchase-channel.js
 * @Description: 获取付费延保-购买渠道 （当前仅支持美加日，默认是美国购买渠道）
 *
 * Copyright (c) 2025 by Hello Tech, All Rights Reserved.
 */
export function getPEWPurchaseChannel() {
  let list = [];
  if (window.pageInfo.cr === 'CA') {
    list = [
      { label: 'Jackery Website', value: 'Jackery Website', type: 'online' },
      { label: 'Amazon', value: 'Amazon', type: 'online' },
      { label: 'Walmart', value: 'Walmart', type: 'offline' },
      { label: 'Costco Canada', value: 'Costco Canada', type: 'offline' },
      { label: 'Canadian Tire Corporation, Limited', value: 'Canadian Tire Corporation, Limited', type: 'offline' },
      { label: 'Sport Chek', value: 'Sport Chek', type: 'offline' },
      { label: 'Sports Experts', value: 'Sports Experts', type: 'offline' },
      { label: 'Craze Outdoors and Supply', value: 'Craze Outdoors and Supply', type: 'offline' },
      { label: 'Bigtent Outdoor Equipment Ltd', value: 'Bigtent Outdoor Equipment Ltd', type: 'offline' },
      { label: 'Gentec International', value: 'Gentec International', type: 'offline' },
      { label: 'VENTMERE LTD', value: 'VENTMERE LTD', type: 'offline' },
      { label: 'Tanguay inc / BMTC', value: 'Tanguay inc / BMTC', type: 'offline' },
      { label: 'Others', value: 'Others', type: 'offline' }
    ]
  } else if (window.pageInfo.cr === 'JP') {
    list = [
      { label: '公式サイト', value: '公式サイト', type: 'online' },
      { label: 'Yahoo!', value: 'Yahoo!', type: 'online' },
      { label: '楽天', value: '楽天', type: 'online' },
      { label: 'アマゾン', value: 'アマゾン', type: 'online' },
      { label: '法人', value: '法人', type: 'offline' },
      {
        label: '店舗', value: [
          { label: '家電量販店', value: '家電量販店', type: 'offline' },
          { label: '小売店', value: '小売店', type: 'offline' },
          { label: 'ホームセンター', value: 'ホームセンター', type: 'offline' },
          { label: 'カー用品', value: 'カー用品', type: 'offline' },
        ]
      },
      { label: 'その他（当選品/コラボなど）', value: 'その他（当選品/コラボなど）', type: 'offline' },
    ]
  } else {
    list = [
      { label: 'Jackery Website', value: 'Jackery Website', type: 'online' },
      { label: 'Amazon', value: 'Amazon', type: 'online' },
      { label: 'eBay Jackery Official Store', value: 'eBay Jackery Official Store', type: 'online' },
      { label: 'Walmart', value: 'Walmart', type: 'offline' },
      { label: 'Harbor Freight Tools', value: 'Harbor Freight Tools', type: 'offline' },
      { label: 'The Home Depot', value: 'The Home Depot', type: 'offline' },
      { label: 'Costco', value: 'Costco', type: 'offline' },
      { label: "Lowe's", value: "Lowe's", type: 'offline' },
      { label: 'BestBuy', value: 'BestBuy', type: 'offline' },
      { label: 'B&H', value: 'B&H', type: 'offline' },
      { label: 'Camping World', value: 'Camping World', type: 'offline' },
      { label: 'Others', value: 'Others', type: 'offline' },
    ]
  }
  return list;
}